
import Vue from "vue"
import { VueConstructor } from "vue/types/umd"
import { EventBus } from "@/plugins/eventBus"
import axios from "axios"
import format from "date-fns/format"

export default (Vue as VueConstructor<Vue>).extend({
  name: "ArchiveDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedSW: {
      type: Array as () => string[],
      required: true
    },
    isReactivate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    inputValue: {
      get(): boolean {
        return this.value
      },
      set(val: boolean) {
        this.$emit('input', val)
      }
    },
    selectedWorkersText(): string {
      const count = this.selectedSW.length;
      return count + ' ' + this.$vuetify.lang.t(`$vuetify.${count > 1 ? 'workers' : 'worker'}`);
    }
  },
  methods: {
    checkSelection() {
      // Display snackbar error and hide component if no super_worker in selection
      if (this.selectedSW.length === 0) {
        EventBus.$emit('snackbar', { message: this.$vuetify.lang.t('$vuetify.empty_selection'), color: 'error' })
        this.inputValue = false
        return false
      }
      return true
    },
    async submit() {
      this.loading = true;
      
      try {
        const requestData: {[key: string]: any} = {};
        
        // Create request body with deleted_at updates for all selected workers
        this.selectedSW.forEach((workerId: string) => {
          requestData[workerId] = { 
            deleted_at: this.isReactivate ? null : format(new Date(), "yyyy-MM-dd HH:mm:ss")
          };
        });
        
        // Make API request
        await axios.put('/v1/workers', requestData);
        
        // Show success message
        EventBus.$emit('snackbar', {
          message: this.$vuetify.lang.t(`$vuetify.success_${this.isReactivate ? 'reactivate' : 'archive'}${this.selectedSW.length > 1 ? 's' : ''}`),
          color: 'success'
        });
        
        // Close dialog
        this.inputValue = false;
        
        // Emit completed event so parent can refresh data if needed
        this.$emit('completed');
      } catch (error) {
        EventBus.$emit('snackbar', { axiosError: error });
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    inputValue(val: boolean) {
      if (val === true) {
        // Check if selection is empty when dialog opens
        if (!this.checkSelection()) return;
      }
    }
  }
})
